import type { FunctionComponent } from 'react';

import type { SvgProps } from './types';

export const AbbCalendar: FunctionComponent<SvgProps> = ({ fill = '#1f1f1f', size = 14, ...props }) => {
  return (
    <>
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width={size} height={size} fill={fill} {...props}>
        <g id='Box'>
          <rect fill='none' width={size} height={size} />
        </g>
        <g id='Final_icons_-_Common' data-name='Final icons - Common'>
          <path d='M17,3V1H15V3H9V1H7V3H2V20a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V3ZM15,3h2V5H15ZM7,3H9V5H7ZM20,20H4V7H20Z' />
          <rect x='15' y='10' width='2' height='2' />
          <rect x='7' y='10' width='2' height='2' />
          <rect x='11' y='10' width='2' height='2' />
          <rect x='7' y='14' width='2' height='2' />
          <rect x='11' y='14' width='2' height='2' />
        </g>
      </svg>
    </>
  );
};
